import React, { useState } from "react";

const FormSelect = (props) => {
  const [focused, setFocused] = useState(false);
  const {
    containerStyle,
    defaultOptionLabel,
    items,
    name,
    id,
    label,
    hint,
    value,
    onChange,
    errorMessage,
    required,
    ...inputProps
  } = props;

  const handleFocused = (e) => {
    setFocused(true);
  };

  return (
    <div className={containerStyle}>
      <label htmlFor={name} className="form-label">
        {label}
      </label>
      <select
        className="form--select"
        aria-label={label}
        name={name}
        onChange={(e) => onChange(e)}
        onBlur={handleFocused}
        {...inputProps}
        focused={focused.toString()}
        required
      >
        {/*<option selected>{ defaultOptionLabel }</option>*/}
        {items.map((item) => {
          return <option value={item.value}>{item.label}</option>;
        })}
      </select>
      <div id={`${name}Help`} className="form-text">
        {hint}
      </div>
      <span className={`dz:error-message dz:error--show-`}>{errorMessage}</span>
    </div>
  );
};

export default FormSelect;
